import { render, staticRenderFns } from "./Shrub.html?vue&type=template&id=f5e4ce3e&scoped=true&external"
import script from "./Shrub.vue?vue&type=script&lang=js"
export * from "./Shrub.vue?vue&type=script&lang=js"
import style0 from "./Shrub.scss?vue&type=style&index=0&id=f5e4ce3e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e4ce3e",
  null
  
)

export default component.exports